import { Ref, computed } from 'vue'
import { CardState } from '../types'
import GraphToplistCard from '@/components/AnalyticsDashboard/components/cards/GraphToplistCard.vue'
import { ToplistResponse } from '@/api-client/models/utilization/Contracts'
import { AnalyticFilters, FeatureType } from './useFilters'
import { DataFetcher } from '@/composables/useDataFetcher'

type PlotMap = Record<string, { is: any; props: DataSource }>

type DataSource = {
  data: any
  state: CardState
  hasError: Error | undefined
}

function getState<Data>(dataRef: DataFetcher<Data>) {
  if (dataRef.isLoading.value) {
    return 'LOADING'
  }
  if (dataRef.error.value) {
    return 'ERROR'
  }
  return 'ACTIVE'
}

export function usePlotComponentMap(
  toplistRef: DataFetcher<ToplistResponse>,
  filterState: Ref<AnalyticFilters<FeatureType.Utilization> | undefined>
) {
  const invertDataSource = <Response>(dataSource: DataFetcher<Response>): DataSource => ({
    data: dataSource.data.value,
    hasError: dataSource.error.value,
    state: getState(dataSource)
  })
  const toplist = computed<DataSource>(() => invertDataSource(toplistRef))

  const plotMap = computed<PlotMap>(() => ({
    USAGE_AND_BOOKING_PER_ROOM: {
      is: GraphToplistCard,
      props: {
        ...toplist.value,
        onlyBookable: filterState.value?.onlyBookable ?? false
      }
    }
  }))

  return plotMap
}
